import styled from 'styled-components/macro'

import { Button, Text } from '@loadsmart/miranda-react'

import { screen } from 'legacy/styles/screen'

export const ResponsiveText = styled(Text)`
  display: none;

  ${screen.md} {
    display: inline;
  }
`

export const ResponsiveButton = styled(Button)`
  width: 100%;

  ${screen.md} {
    width: auto;
  }
`
